import type { GlobalState, TabArgs, TabState } from '../types';

import { getCurrentTabId } from '../../util/establishMultitabRole';
import { createInitialTabState } from '../helpers/tabStateFactory';

export function updateTabState<T extends GlobalState>(
  global: T,
  tabStatePartial: Partial<TabState>,
  ...[tabId = getCurrentTabId()]: TabArgs<T>
): T {
  const byTabId = global.byTabId || {};
  const currentTabState = byTabId[tabId]
    || createInitialTabState(global, tabId, Boolean(tabStatePartial.isMasterTab));

  return {
    ...global,
    byTabId: {
      ...byTabId,
      [tabId]: {
        ...currentTabState,
        ...tabStatePartial,
      },
    },
  };
}
